import React, {useEffect, useRef, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Lena_Chris from '../images/Lena_Chris_v1.png';
import arrowLeft from '../images/arrowLeftWhite.svg';

const InfoModal = (props) => {

    const {setInfoModal, infoModal} = props;
    const [lenaRevealed, setLenaRevealed] = useState(false);
    const [chrisRevealed, setChrisRevealed] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = Lena_Chris;
    }, []);

    const hideInfoModal = () => {
        setInfoModal(false);
    };

    return (<>
                <Modal size="sm"
                       fullscreen={true}
                       id={'info-modal'}
                       scrollable={false}
                       dialogClassName={'d-flex align-items-center m-0'}
                       aria-labelledby="contained-modal-title-vcenter"
                       centered
                       backdrop={true}
                       className={'p-3 m-0 info-modal'}
                       show={infoModal} onHide={hideInfoModal}
                >
                    <Modal.Body className={'p-0'}>
                        <img className="w-100" src={Lena_Chris}
                                                         alt="Lena_Chris"/>
                        <div className="p-4" style={{background:'#F4F286'}}>
                            <h2>A little history</h2>
                            <p>Developed by Dr Lena Mattheis and Prof Chris Mounsey, ListenQueer began with two objectives in mind.<br/><br/>
Firstly: to seek out hidden LGBTQIA+ histories. <br/><br/>
Secondly: to find safe passage through busy city streets. The result is a series of audio-guided walks, compiled by two queer history connoisseurs who navigate the world with visual impairments. <br/><br/>
Each tour is designed to be practical, accessible and rich in forgotten history.<br/><br/>
ListenQueer brings to light narratives from the past that have the power to transform lives today. Perhaps, one day, your story will be part of that history, too…
 </p>
 <h2 className="mt-5">A little about us</h2>
 <div>
 <p><strong>Lena (they/she) </strong></p>
 <p>Lena (they/she) hosts the Queer Lit podcast and has a soft spot for queer Christmas novels.</p>
 <p className="reveal-toggle" onClick={() => setLenaRevealed(!lenaRevealed)}>{lenaRevealed ? 'Reveal less -' : 'Reveal more +'}</p>
 {lenaRevealed && <p>
    A lecturer in contemporary literature at the University of Surrey, Lena specialises in queer and trans writing, narrative studies and literary geography. Since April 2021, Lena has been hosting the Queer Lit podcast, recording conversations with Sara Ahmed, Susan Stryker, Sue Lanser, Jack Halberstam, Lee Edelman, Meg-John Barker and many other inspiring scholars. Lena contributes to podcasting workshops around the world, in between teaching modules that range from Queer Ecologies and Environmental Writing, to Spoken Word and Slam Poetry. A prolific essay writer, Lena’s work has been published in journals such as Narrative, Transnational Literature, Literary Geographies, or WSQ.
    <br/><br/>
<strong> You might also like to look into Lena’s books:</strong><br/><br/>
Queer Forms and Pronouns: Gender Non-conformity in Anglophone Literature (Oxford University Press 2026)<br/><br/>
Translocality in Contemporary City Novels (Palgrave, 2021)<br/><br/>
    <strong> Get in touch:</strong><br/>IG: @Lena_Mattheis
    <br/><br/>
    <strong> Follow the pod:</strong><br/>@queerlitpodcast
    </p>}
 </div>
 <hr className="my-4" style={{color:'#001233'}}/>
 <div className="mb-4">
 <p><strong>Chris (he/him) </strong></p>
 <p>Chris (he/him) works in disability studies and wears the best dungarees in town.</p>
 <p className="reveal-toggle" onClick={() => setChrisRevealed(!chrisRevealed)}>{chrisRevealed ? 'Reveal less -' : 'Reveal more +'}</p>
 {chrisRevealed && <p>A Professor of Eighteenth-Century English literature at the University of Winchester, Chris specialises in the histories of sexualities and disabilities. Before his vision was impaired, Chris wrote and directed a number of plays, while also running conferences on 18thC and queer history. He remains an active member of the American Society for Eighteenth-Century Studies Queer Caucus, the Disability Studies Caucus and the University’s Culture-Media-Text Research Centre.<br/><br/><strong>Having authored, edited and contributed to numerous publications and journals, Chris has an extensive bibliography you might like to explore:</strong><br/><br/>Queer People: Negotiations and Expressions of Homosexuality 1700-1800. Lewisburg: Bucknell University Press, 2007, ISBN: 0-8387-5667-6<br/><br/>Friendship and Same-Sex Love. Studies in English Literature, SEL, Volume 46, No. 3, Summer, 2006) ISSN: 0039-3657<br/><br/>Eighteenth-Century British Erotica, Volume 1: Pleasures, Comforts and Plagues of the early eighteenth century LondonPickering and Chatto, 2002, ISBN: 1 85196 742 7<br/><br/>Christopher Smart: Clown of God Lewisburg: Bucknell University Press, 2001, ISBN: 0-8387-5483-X<br/><br/>Presenting Gender: Changing Sex in Early Modern CultureLewisburg: Bucknell University Press, 2001, ISBN: 0-8387-5477-5</p>}
 </div>


                            <a className="button d-inline-flex align-items-center justify-content-center gap-3"
                               onClick={(e) => {
                                   e.preventDefault();
                                   setInfoModal(false);
                               }}><img src={arrowLeft} alt="arrowLeft"/><span>Back to the map</span></a>
                        </div>

                    </Modal.Body>
                </Modal>
            </>
    )
            ;
};

export default InfoModal;
